<template>
    <transition name="main" mode="out-in">
        <div
            v-if="showPhaseOne || showPhaseTwo"
            key="main-1"
            @mouseover="checkAnimation"
            class="offer-card-container"
        >
            <div class="offer-card-title">Artist Offer</div>
            <transition :name="`phase-${getPhaseName}`" mode="out-in">
                <div v-if="showPhaseOne" key="1" class="offer-card-content">
                    <div class="content-title">$260 Payout / 1.5 hr Set</div>
                    <div class="content-subtitle">Available 12:00-10:00PM</div>
                    <div class="content-text">
                        “Hey Maxine!
                        <br />
                        <br />
                        We’d be stoked to play your bar on the 24th, either solo or with some
                        other acts. We have performed at various venues across the country. You
                        can check out our music, videos, and press reviews on our profile page
                        or on our social media pages . We think that our music would fit well
                        with your booker and your audience.”
                    </div>
                </div>
                <div v-else-if="showPhaseTwo" key="2" class="offer-card-content">
                    <div class="content-title">Counter Offer</div>
                    <div class="counter-payouts">
                        <div class="counter-price-input">
                            <label for="counter-price">Proposed Payout</label>
                            <input
                                v-model="counterPrice"
                                type="text"
                                name="counter-price"
                                placeholder="Eg. $100"
                            />
                        </div>
                        <div class="counter-price-input">
                            <label for="counter-duration-input">Proposed Set</label>
                            <input
                                v-model="counterDuration"
                                type="text"
                                name="counter-duration-input"
                                placeholder="Eg. 1 hour"
                            />
                        </div>
                    </div>
                    <div class="counter-message">
                        <div class="counter-message-input">
                            <label for="counter-message-input">Message</label>
                            <input
                                v-model="counterMessage"
                                type="text"
                                name="counter-message-input"
                                placeholder="Eg. $100"
                            />
                        </div>
                    </div>
                </div>
                <div v-else-if="showPhaseThree" key="3" class="offer-card-content">
                    <div class="content-subtitle">Counter Offer Submitted!</div>
                    <div class="content-title">$200 Payout / 1hr Set</div>
                    <div class="content-text">
                        “Hey Pixel Rainbow! Shoot, $200 is the most we can do for this show.
                        Any chance we can make that work”
                    </div>
                </div>
            </transition>
            <div class="offer-card-btns">
                <button v-if="showPhaseOne" ref="accept-btn" class="accept-btn">Accept</button>
                <button
                    v-if="showPhaseTwo && !showSubmitting"
                    ref="accept-btn"
                    class="accept-btn"
                >
                    {{ width > 600 ? 'Submit Counter Offer' : 'Submit' }}
                </button>
                <button
                    v-else-if="showPhaseTwo && showSubmitting"
                    ref="accept-btn"
                    class="accept-btn"
                >
                    Submitting...
                </button>
                <button
                    v-if="showPhaseOne || showPhaseTwo"
                    ref="counter-btn"
                    class="counter-btn"
                >
                    Counter
                </button>
                <button v-if="showPhaseOne" ref="decline-btn" class="decline-btn">
                    Decline
                </button>
                <button v-else-if="showPhaseTwo" ref="decline-btn" class="decline-btn">
                    Cancel
                </button>
            </div>
        </div>
        <div
            v-else
            key="main-2"
            @mouseover="checkAnimation"
            class="offer-card-container small-card"
        >
            <div class="offer-card-title">Artist Offer</div>
            <div class="offer-card-content">
                <div class="content-subtitle">Counter Offer Submitted!</div>
                <div class="content-title">$200 Payout / 1hr Set</div>
                <div class="content-text">
                    “Hey Pixel Rainbow! Shoot, $200 is the most we can do for this show. Any
                    chance we can make that work”
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import checkScreen from '../../../mixins/check-screen'
    import { useSearchParams } from '@/composables/utils/useSearchParams'

    const ANIMATION_LABELS = {
        'initial-animation': 0,

        'counter-btn-clicked': 1,

        'counter-btn-fade': 2,

        'begin-phase-two': 3,

        'fill-in-price': 4,

        'fill-in-set': 5,

        'fill-in-message': 6,

        'accept-btn-clicked': 7,

        'accept-btn-submitting': 8,

        'begin-phase-three': 9
    }

    export default {
        name: 'OfferCard',
        mixins: [checkScreen],
        props: {
            animate: {
                required: true,
                type: Boolean
            }
        },
        setup() {
            const { getVal } = useSearchParams()

            const booker = getVal('booker')

            return {
                booker
            }
        },
        data: () => ({
            showSubmitting: false,
            animationTimeout: null,
            resetTimeout: null,
            resetTimer: 4000,
            animating: false,
            currentAnimation: 0,
            counterPrice: '',
            counterDuration: '',
            counterMessage: '',

            animationValues: {
                price: '$200',
                duration: '1hr',
                message:
                    'Hey Pixel Rainbow! Shoot, $200 is the most we can do for this show. Any chance we can make that work'
            },
            animations: [
                {
                    id: ANIMATION_LABELS['initial-animation'],
                    phase: 'one',
                    refs: null,
                    timeout: 700
                },
                {
                    id: ANIMATION_LABELS['counter-btn-clicked'],
                    phase: 'one',
                    refs: [
                        {
                            ref: 'counter-btn',
                            class: ['counter-btn-animate-clicked']
                        }
                    ],
                    animate: true,
                    finished: false,
                    timeout: 1000
                },
                {
                    id: ANIMATION_LABELS['counter-btn-fade'],
                    phase: 'two',
                    refs: [
                        {
                            ref: 'counter-btn',
                            class: ['counter-btn-fade-away']
                        }
                    ],
                    timeout: 1000
                },
                {
                    id: ANIMATION_LABELS['begin-phase-two'],
                    phase: 'two',
                    refs: null,
                    timeout: 700
                },
                {
                    id: ANIMATION_LABELS['fill-in-price'],
                    phase: 'two',
                    refs: null,
                    timeout: 500
                },
                {
                    id: ANIMATION_LABELS['fill-in-set'],
                    phase: 'two',
                    refs: null,
                    timeout: 500
                },
                {
                    id: ANIMATION_LABELS['fill-in-message'],
                    phase: 'two',
                    refs: null,
                    timeout: 500
                },
                {
                    id: ANIMATION_LABELS['accept-btn-clicked'],
                    phase: 'two',
                    refs: [
                        {
                            ref: 'accept-btn',
                            class: ['accept-btn-animate-clicked']
                        }
                    ],
                    timeout: 300
                },
                {
                    id: ANIMATION_LABELS['accept-btn-submitting'],
                    phase: 'two',
                    refs: null,
                    timeout: 500
                },
                {
                    id: ANIMATION_LABELS['begin-phase-three'],
                    phase: 'three',
                    refs: null,
                    timeout: 1500
                }
            ]
        }),

        methods: {
            startAnimations() {
                if (!this.animating) this.animating = true

                let animation = this.animations.find((a) => a.id === this.currentAnimation)

                if (animation.refs) {
                    this.animateEl(animation)
                }
                this.handleAnimations(animation)
            },

            handleAnimations(animation) {
                this.animationTimeout = setTimeout(() => {
                    if (this.currentAnimation === this.animations.length - 1) {
                        this.resetAnimations()
                    } else {
                        this.currentAnimation = this.currentAnimation + 1
                        this.startAnimations()
                    }
                }, animation.timeout)
            },

            animateEl(animation) {
                for (let i = 0; i < animation.refs.length; i++) {
                    if (!this.$refs[animation.refs[i].ref]) continue

                    let classList = this.$refs[animation.refs[i].ref].classList

                    for (let j = 0; j < animation.refs[i].class.length; j++) {
                        classList.add(animation.refs[i].class[j])
                    }
                }
            },

            resetAnimations() {
                this.resetTimeout = setTimeout(() => {
                    this.currentAnimation = 0
                    this.animating = false
                    this.removeAnimations()
                }, this.resetTimer)
            },

            removeAnimations() {
                for (let a = 0; a < this.animations.length; a++) {
                    let animation = this.animations[a]

                    if (!animation.refs) continue

                    for (let i = 0; i < animation.refs.length; i++) {
                        if (!this.$refs[animation.refs[i].ref]) continue
                        let classList = this.$refs[animation.refs[i].ref].classList

                        for (let j = 0; j < animation.refs[i].class.length; j++) {
                            classList.remove(animation.refs[i].class[j])
                        }
                    }
                }
            },

            checkAnimation() {
                this.resetTimeout = setTimeout(() => {
                    if (!this.animating) {
                        this.startAnimations()
                    }
                }, this.resetTimer)
            },

            manageAnimationSideEffects(index) {
                switch (index) {
                    case this.ANIMATION_LABELS['fill-in-price']:
                        this.counterPrice = this.animationValues.price
                        break
                    case this.ANIMATION_LABELS['fill-in-set']:
                        this.counterDuration = this.animationValues.duration
                        break
                    case this.ANIMATION_LABELS['fill-in-message']:
                        this.counterMessage = this.animationValues.message
                        break
                    case this.ANIMATION_LABELS['accept-btn-submitting']:
                        this.showSubmitting = true
                        break
                    case this.ANIMATION_LABELS['begin-phase-three']:
                        this.counterPrice = ''
                        this.counterDuration = ''
                        this.counterMessage = ''
                        this.showSubmitting = false
                        break
                    default:
                        return
                }
            }
        },

        computed: {
            ANIMATION_LABELS: () => ANIMATION_LABELS,

            showPhaseOne: (self) =>
                self.animations.find((a) => a.id === self.currentAnimation).phase === 'one',

            showPhaseTwo: (self) =>
                self.animations.find((a) => a.id === self.currentAnimation).phase === 'two',

            showPhaseThree: (self) =>
                self.animations.find((a) => a.id === self.currentAnimation).phase === 'three',

            getPhaseName: (self) =>
                self.animations.find((a) => a.id === self.currentAnimation).phase
        },

        watch: {
            animate: function (animate) {
                if (animate) {
                    this.startAnimations()
                }
            },

            currentAnimation: function (index) {
                this.manageAnimationSideEffects(index)
            }
        },

        beforeDestory() {
            clearTimeout(this.animationTimeout)
            clearTimeout(this.resetTimeout)
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    @keyframes btn-clicked {
        0% {
            opacity: 1;
            transform: scale(1);
        }
        25% {
            opacity: 0.4;
            transform: scale(0.99);
        }
        50% {
            opacity: 0.4;
            transform: scale(0.98);
        }
        75% {
            opacity: 0.4;
            transform: scale(0.99);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }

    @keyframes btn-leave {
        0% {
            opacity: 1;
            max-width: 190px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        10% {
            opacity: 0.9;
            max-width: 160px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        20% {
            opacity: 0.8;
            max-width: 140px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        30% {
            opacity: 0.7;
            max-width: 120px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        40% {
            opacity: 0.6;
            max-width: 100px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        50% {
            opacity: 0.5;
            max-width: 80px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        60% {
            opacity: 0.4;
            max-width: 60px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        70% {
            opacity: 0.3;
            max-width: 40px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        80% {
            opacity: 0.2;
            max-width: 20px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        90% {
            opacity: 0.1;
            max-width: 0px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        100% {
            opacity: 0;
            max-width: 0px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
    }
    @keyframes button-enter {
        0% {
            opacity: 1;
            max-width: 0px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        10% {
            opacity: 1;
            max-width: 5px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        20% {
            opacity: 1;
            max-width: 10px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        30% {
            opacity: 1;
            max-width: 20px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        40% {
            opacity: 1;
            max-width: 40px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        50% {
            opacity: 1;
            max-width: 60px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        60% {
            opacity: 1;
            max-width: 80px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        70% {
            opacity: 1;
            max-width: 100px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        80% {
            opacity: 1;
            max-width: 120px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        90% {
            opacity: 1;
            max-width: 140px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
        100% {
            opacity: 1;
            max-width: 160px;
            max-height: 40px;
            border: 1px solid #cdeb09;
            background: #cdeb09;
        }
    }

    .phase-two-enter,
    .phase-one-enter,
    .phase-two-leave-to .phase-one-leave-to {
        opacity: 0;
    }

    .phase-two-enter-active,
    .phase-one-enter-active,
    .phase-two-leave-active .phase-one-leave-active {
        transition: opacity 0.5s linear;
    }

    .phase-three-enter,
    .phase-three-leave-to {
        opacity: 0;
        max-height: 376px;
    }

    .phase-three-enter-to,
    .phase-three-leave-to {
        opacity: 1;
        max-height: 336px;
    }

    .phase-three-enter-active,
    .phase-three-leave-active {
        transition: all 0.5s linear;
    }

    .main-enter {
        opacity: 0;
        max-height: 286px;
    }
    .main-enter-to {
        opacity: 1;
        max-height: 376px;
    }
    .main-leave {
        opacity: 1;
        max-height: 376px;
    }
    .main-leave-to {
        opacity: 0;
        max-height: 286px;
    }
    .main-enter-active {
        transition: all 0.5s linear;
    }
    .main-leave-active {
        transition: all 0.5s linear;
    }

    label {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    input {
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        padding: 12px 15px 15px 15px;
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    input::placeholder {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }

    .offer-card-container {
        background: #262626;
        max-width: 620px;
        min-height: 376px;
        width: 100%;
        padding: 25px;
        border-radius: 15px;
        display: flex;
        flex-direction: column;
        gap: 25px;
        justify-content: center;
        align-items: flex-start;
        overflow: hidden;

        .offer-card-title {
            margin-right: auto;
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 22px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.22px;
        }

        .offer-card-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
            gap: 15px;

            .content-title {
                color: #cdeb09;
                font-family: Instrument Sans;
                font-size: 38px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -0.76px;
            }

            .content-subtitle {
                color: #cdeb09;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }

            .content-text {
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: 130%;
                letter-spacing: 0.14px;
            }

            .counter-payouts {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                gap: 10px;

                .counter-price-input,
                .counter-duration-input {
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                    width: 26%;
                }
            }

            .counter-message {
                width: 100%;

                .counter-message-input {
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                }
            }
        }

        .offer-card-btns {
            display: flex;
            flex-direction: row;
            padding-top: 10px;
            justify-content: center;
            align-items: center;
            align-self: stretch;
            gap: 10px;

            .accept-btn,
            .counter-btn,
            .decline-btn {
                flex: 1 0 0;
                color: #262626;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
                padding: 7px 20px 10px 20px;
                border-radius: 100px;
                border: 1px solid #cdeb09;
                background: #cdeb09;
            }

            .decline-btn {
                background: #262626;
                color: #cdeb09;
            }

            .counter-btn-animate-clicked {
                animation: btn-clicked 0.5s;
                animation-timing-function: ease-in-out;
            }

            .accept-btn-animate-clicked {
                animation: btn-clicked 0.5s;
                animation-timing-function: ease-in-out;
            }

            .counter-btn-fade-away {
                animation: btn-leave 0.5s;
                animation-timing-function: ease-in-out;
                padding: 0px;
                max-width: 0px;
                max-height: 0px;
                background: #262626;
                border: none;
            }

            .vertical-remove-btn {
                animation: btn-remove 0.5s;
                animation-timing-function: ease-in-out;
                background: #262626;
                padding: 0px;
                max-width: 0px;
                max-height: 0px;
                border: none;
            }
        }
    }
    .small-card {
        height: auto;
    }

    @media (max-width: 600px) {
        .offer-card-container .offer-card-content .counter-price-input {
            width: 30% !important;
        }
    }
</style>
